var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"organizations":_vm.organizations},on:{"cancel":function($event){return _vm.cancel()},"finished":_vm.organizationMerged}})}
var staticRenderFns = []

export { render, staticRenderFns }